module.exports = __webpack_public_path__ + "static/media/core.f73ddbe0.png";